import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-8 space-y-5" }
const _hoisted_4 = { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_5 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_6 = { class: "text-2xl font-bold md:text-4xl" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-2 sm:flex sm:flex-wrap sm:items-center" }
const _hoisted_8 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_9 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-5" }
const _hoisted_10 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-5" }
const _hoisted_11 = { class: "text-sm font-semibold text-slate-500" }
const _hoisted_12 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_13 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_14 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_15 = { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }
const _hoisted_16 = { class: "text-xs text-slate-500" }
const _hoisted_17 = { class: "overflow-x-auto" }
const _hoisted_18 = { class: "min-w-full text-sm" }
const _hoisted_19 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "px-4 py-3 text-gray-500 align-middle" }
const _hoisted_23 = { class: "px-4 py-3 text-gray-700 align-middle whitespace-nowrap" }
const _hoisted_24 = { class: "px-4 py-3 align-middle" }
const _hoisted_25 = { class: "font-medium text-gray-900 whitespace-nowrap" }
const _hoisted_26 = {
  key: 0,
  class: "text-xs text-gray-500 whitespace-nowrap"
}
const _hoisted_27 = {
  key: 1,
  class: "text-xs text-gray-500 whitespace-nowrap"
}
const _hoisted_28 = { class: "px-4 py-3 text-gray-700 align-middle" }
const _hoisted_29 = { class: "px-4 py-3 text-gray-700 align-middle whitespace-nowrap" }
const _hoisted_30 = { class: "px-4 py-3 font-mono text-xs text-gray-600 align-middle" }
const _hoisted_31 = { class: "px-4 py-3 font-medium text-right text-gray-900 align-middle whitespace-nowrap" }
const _hoisted_32 = { class: "px-4 py-3 align-middle" }
const _hoisted_33 = { class: "px-4 py-3 align-middle" }
const _hoisted_34 = { class: "px-4 py-3 align-middle" }
const _hoisted_35 = {
  key: 0,
  class: "inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-sm font-semibold text-blue-700"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_38 = { class: "px-4 py-3 text-right align-middle" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "flex flex-col items-center justify-between gap-2 border-t border-slate-100 px-6 py-4 sm:flex-row" }
const _hoisted_41 = { class: "text-xs text-slate-500" }
const _hoisted_42 = { class: "inline-flex" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { GET_DONASI } from '@/store/donasi.module';
import ModalForm from '@/components/modal/FormDonation.vue';
import IcLink from '@/assets/svg/ic-link.vue';
import IcEdit from '@/assets/svg/ic-edit.vue';
import Swal from 'sweetalert2';
import { useStore } from 'vuex';
import { formatDate } from '@/utils';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';

interface DonationRow {
  id?: string | number;
  date?: string;
  createdAt?: string;
  name?: string;
  email?: string;
  noWhatsapp?: string;
  donationType?: string;
  faculty?: {
    name?: string;
    kodeUnik?: string;
  };
  kodeUnik?: string;
  grossAmount?: number | string | null;
  amount?: number | string | null;
  paymentMethod?: string;
  paymentStatus?: string;
  proof?: string;
}

const excelUrl =
  'https://docs.google.com/spreadsheets/d/13w3FcIz4jjIBcf7DvG_83FmU8NBss_MkGt4lM7U6x6k/edit?usp=sharing';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonasiView',
  setup(__props) {

const store = useStore();

const isLoading = ref(true);
const page = ref(1);
const limit = ref(10);
const search = ref('');
const paymentMethod = ref('');
const paymentStatus = ref('');
const donationType = ref('');
const isImageModalOpen = ref(false);
const selectedImage = ref('');
const title = ref('Donasi');

const isOpened = ref(false);
const currentId = ref<string | undefined>(undefined);
const dataUpdate = ref<Partial<DonationRow>>({});
let searchTimer: ReturnType<typeof setTimeout> | null = null;

const pageLimitOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
];
const paymentMethodOptions = [
  { value: '', label: 'Semua' },
  { value: 'manual', label: 'Manual' },
  { value: 'midtrans', label: 'Midtrans' },
];
const paymentStatusOptions = [
  { value: '', label: 'Semua' },
  { value: 'pending', label: 'Menunggu' },
  { value: 'settlement', label: 'Lunas' },
  { value: 'expired', label: 'Kedaluwarsa' },
  { value: 'failed', label: 'Gagal' },
  { value: 'refunded', label: 'Dikembalikan' },
];
const donationTypeFilterOptions = [
  { value: '', label: 'Semua' },
  { value: 'iuran_sukarela', label: 'Iuran Sukarela' },
  { value: 'kontribusi_anggota', label: 'Kontribusi Anggota' },
  { value: 'kontribusi_donatur', label: 'Kontribusi Donatur' },
  { value: 'pembelian_merchandise', label: 'Pembelian Merchandise' },
  { value: 'kontribusi_sukarela', label: 'Kontribusi Sukarela' },
];

const openAddModal = () => {
  currentId.value = undefined;
  dataUpdate.value = {};
  isOpened.value = true;
};

const editItem = (item: DonationRow) => {
  dataUpdate.value = { ...item };
  currentId.value = String(item.id);
  isOpened.value = true;
};

const handleModalClose = async () => {
  isOpened.value = false;
  currentId.value = undefined;
  dataUpdate.value = {};
  await getData();
};

const computedData = computed<DonationRow[]>(() => {
  const donasi = store.getters.donasi;
  return donasi?.data || [];
});

const pagination = computed(() => {
  const donasi = store.getters.donasi;
  return donasi?.pagination || {};
});

const startNumber = computed(() => pagination.value?.start || 1);
const settlementCount = computed(() =>
  computedData.value.filter((item) => item?.paymentStatus === 'settlement').length
);
const pendingCount = computed(() =>
  computedData.value.filter((item) => item?.paymentStatus === 'pending').length
);
const manualCount = computed(() =>
  computedData.value.filter((item) => item?.paymentMethod !== 'midtrans').length
);
const displayedAmountTotal = computed(() =>
  computedData.value.reduce((total, item) => {
    const amount = Number(item?.grossAmount || item?.amount || 0);
    return Number.isNaN(amount) ? total : total + amount;
  }, 0)
);

const kpiCards = computed(() => [
  {
    title: 'Total Data',
    value: String(pagination.value?.totalEntries || computedData.value.length),
    description: `${computedData.value.length} donasi ditampilkan`,
  },
  {
    title: 'Sudah Lunas',
    value: String(settlementCount.value),
    description: 'Transaksi settlement di halaman ini',
  },
  {
    title: 'Menunggu',
    value: String(pendingCount.value),
    description: 'Transaksi pending di halaman ini',
  },
  {
    title: 'Manual',
    value: String(manualCount.value),
    description: 'Input manual di halaman ini',
  },
  {
    title: 'Nominal Halaman',
    value: formatNominal(displayedAmountTotal.value),
    description: 'Akumulasi nominal yang sedang tampil',
  },
]);

const formatDonationType = (t?: string) => {
  if (!t) return '-';
  return t.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

const formatNominal = (amount?: number | string | null) => {
  if (amount == null || amount === '') return '-';
  const n = Number(amount);
  if (Number.isNaN(n)) return String(amount);
  return `Rp ${n.toLocaleString('id-ID')}`;
};

const methodBadgeClass = (method?: string) =>
  method === 'midtrans' ? 'bg-blue-100 text-blue-700' : 'bg-slate-200 text-slate-700';

const statusBadgeClass = (status?: string) => {
  switch (status) {
    case 'settlement':
      return 'bg-green-100 text-green-700';
    case 'pending':
      return 'bg-yellow-100 text-yellow-700';
    case 'expired':
      return 'bg-slate-200 text-slate-700';
    case 'failed':
      return 'bg-red-100 text-red-700';
    case 'refunded':
      return 'bg-purple-100 text-purple-700';
    default:
      return 'bg-slate-100 text-slate-600';
  }
};

const getData = async () => {
  isLoading.value = true;
  try {
    await store.dispatch(GET_DONASI, {
      data: {
        search: search.value,
        limit: limit.value,
        page: page.value,
        paymentMethod: paymentMethod.value || undefined,
        paymentStatus: paymentStatus.value || undefined,
        donationType: donationType.value || undefined,
      },
    });
  } finally {
    isLoading.value = false;
  }
};

const onSearchInput = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    page.value = 1;
    getData();
  }, 350);
};

onMounted(getData);

const openImageModal = (imageUrl: string) => {
  selectedImage.value = imageUrl;
  isImageModalOpen.value = true;
};
const closeImageModal = () => {
  isImageModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: title.value }, null, 8, ["breadcrumb"]),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value ? 'Edit' : 'Tambah'} ${title.value}`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60",
          onClick: closeImageModal
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Bukti bayar manual",
            class: "max-w-full max-h-full rounded-md shadow-lg"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(title.value), 1),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, "Donasi manual dan online Midtrans tercatat dalam satu daftar.", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl sm:w-auto",
              onClick: openAddModal
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                class: "w-4 h-4"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
                  "clip-rule": "evenodd"
                })
              ], -1),
              _createTextVNode(" Tambah Donasi ", -1)
            ]))]),
            _createElementVNode("a", {
              href: excelUrl,
              target: "_blank",
              rel: "noopener",
              class: "inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-white shadow-lg transition-all hover:-translate-y-px hover:bg-emerald-400 hover:shadow-xl sm:w-auto"
            }, [
              _cache[13] || (_cache[13] = _createTextVNode(" Excel ", -1)),
              _createVNode(IcLink, { class: "w-4 h-4" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Per halaman", -1)),
            _createVNode(AppSelect, {
              modelValue: limit.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event)),
              options: pageLimitOptions,
              onChange: _cache[1] || (_cache[1] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Metode", -1)),
            _createVNode(AppSelect, {
              modelValue: paymentMethod.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentMethod).value = $event)),
              options: paymentMethodOptions,
              onChange: _cache[3] || (_cache[3] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status", -1)),
            _createVNode(AppSelect, {
              modelValue: paymentStatus.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paymentStatus).value = $event)),
              options: paymentStatusOptions,
              onChange: _cache[5] || (_cache[5] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Jenis Donasi", -1)),
            _createVNode(AppSelect, {
              modelValue: donationType.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((donationType).value = $event)),
              options: donationTypeFilterOptions,
              onChange: _cache[7] || (_cache[7] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari Nama", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((search).value = $event)),
              onInput: onSearchInput,
              placeholder: "Ketik nama...",
              class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            }, null, 544), [
              [_vModelText, search.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiCards.value, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.title,
            class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          }, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(card.title), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(card.value), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(card.description), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[21] || (_cache[21] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Donasi"),
            _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Transaksi donasi sesuai filter daftar.")
          ], -1)),
          _createElementVNode("span", _hoisted_16, "Halaman " + _toDisplayString(pagination.value?.currentPage || page.value) + " dari " + _toDisplayString(pagination.value?.totalPages || 1), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-blue-900" }, [
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "No"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Tanggal"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Donatur"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Jenis"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Fakultas"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Kode"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Nominal"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Metode"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Status"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Bukti Manual"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_19, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-4"
                      }, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (computedData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("td", {
                        colspan: "11",
                        class: "px-4 py-12 text-sm text-center text-slate-400 italic"
                      }, "Belum ada donasi.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(computedData.value, (u, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: u.id,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_22, _toDisplayString(startNumber.value + index), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatDate)(u.date || u.createdAt)), 1),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(u.name || '-'), 1),
                          (u.email)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(u.email), 1))
                            : _createCommentVNode("", true),
                          (u.noWhatsapp)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(u.noWhatsapp), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(formatDonationType(u.donationType)), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(u.faculty?.name || '-'), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(u.kodeUnik || u.faculty?.kodeUnik || '-'), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(formatNominal(u.grossAmount || u.amount)), 1),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", {
                            class: _normalizeClass([methodBadgeClass(u.paymentMethod), "inline-block px-2 py-0.5 text-xs font-medium rounded-full capitalize"])
                          }, _toDisplayString(u.paymentMethod === 'midtrans' ? 'Midtrans' : 'Manual'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("span", {
                            class: _normalizeClass([statusBadgeClass(u.paymentStatus), "inline-block px-2 py-0.5 text-xs font-medium rounded-full capitalize"])
                          }, _toDisplayString(u.paymentStatus || 'pending'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          (u.paymentMethod === 'midtrans')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Midtrans "))
                            : (u.proof)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "text-sm font-medium text-indigo-600 hover:underline",
                                  onClick: ($event: any) => (openImageModal(u.proof))
                                }, "Lihat", 8, _hoisted_36))
                              : (_openBlock(), _createElementBlock("span", _hoisted_37, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100 transition-colors",
                            onClick: _withModifiers(($event: any) => (editItem(u)), ["prevent"])
                          }, " Edit ", 8, _hoisted_39)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("span", _hoisted_41, " Menampilkan " + _toDisplayString(pagination.value?.start || 0) + "–" + _toDisplayString(pagination.value?.end || 0) + " dari " + _toDisplayString(pagination.value?.totalEntries || 0) + " entri ", 1),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              class: "rounded-l-lg border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value <= 1,
              onClick: _cache[9] || (_cache[9] = () => { page.value = (pagination.value?.currentPage || 1) - 1; getData(); })
            }, "Sebelumnya", 8, _hoisted_43),
            _createElementVNode("button", {
              class: "rounded-r-lg border-y border-r border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value >= (pagination.value?.totalPages || 1),
              onClick: _cache[10] || (_cache[10] = () => { page.value = (pagination.value?.currentPage || 1) + 1; getData(); })
            }, "Berikutnya", 8, _hoisted_44)
          ])
        ])
      ])
    ])
  ]))
}
}

})